import { createElement } from "react";
import * as LucideIcons from "lucide-react";

import {
  PingAreaIcon,
  PingHideLandmarkIcon,
  PingElevationProfileIcon,
  Ping3DIcon,
  PingPlaceholderIcon,
  PingElevationIcon,
  PingLocationIcon,
  PingAccuracyIconLow,
  PingAccuracyIconMedium,
  PingAccuracyIconHigh,
  PingAccuracyIconVeryHigh,
  PingNotGeocodedIcon,
  PingGeocodedIcon,
  PingHeatmapIcon,
  PingGeocodingAccuracyOriginalIcon,
  PingGeocodingAccuracyPointIcon,
  PingGeocodingAccuracyNonPointIcon,
  PingGeocoderOldIcon,
  PingUploadedFileIcon,
  PingInceptionDateIcon,
  PingExpirationDateIcon,
  PingHurricaneIcon,
  PingFloodIcon,
  PingEarthquakeIcon,
  PingWildfireIcon,
  PingSCSIcon,
  PingCrimeIcon,
  PingTsunamiIcon,
  PingLeveedAreasIcon,
  PingListExpandIcon,
  PingListCollapseIcon,
  PingCsvIcon,
  PingJsonIcon,
  PingEmailIcon,
  PingPdfIcon,
  PingPowerpointIcon,
  PingExcelIcon,
  PingMiscIcon,
  PingAlienIcon,
  PingSinkholeIcon,
  PingDiamondXIcon,
  PingDiamondCheckIcon,
  PingDiamondWarningIcon,
  PingFileEyeIcon,
} from "../../lib/ping-icons";

const CustomIcons = {
  FileEyePing: PingFileEyeIcon,
  AreaPing: PingAreaIcon,
  HideLandmarkPing: PingHideLandmarkIcon,
  ElevationProfilePing: PingElevationProfileIcon,
  ThreeDPing: Ping3DIcon,
  PlaceholderPing: PingPlaceholderIcon,
  ElevationPing: PingElevationIcon,
  LocationPing: PingLocationIcon,
  AccuracyLowPing: PingAccuracyIconLow,
  AccuracyMediumPing: PingAccuracyIconMedium,
  AccuracyHighPing: PingAccuracyIconHigh,
  AccuracyVeryHighPing: PingAccuracyIconVeryHigh,
  NotGeocodedPing: PingNotGeocodedIcon,
  GeocodedPing: PingGeocodedIcon,
  HeatmapPing: PingHeatmapIcon,
  AccuracyOriginalPing: PingGeocodingAccuracyOriginalIcon,
  AccuracyPointPing: PingGeocodingAccuracyPointIcon,
  AccuracyNonPointPing: PingGeocodingAccuracyNonPointIcon,
  GeocodingOldPing: PingGeocoderOldIcon,
  ExcelFilePing: PingAccuracyIconMedium,
  PingUploadedFile: PingUploadedFileIcon,
  InceptionDatePing: PingInceptionDateIcon,
  ExpirationDatePing: PingExpirationDateIcon,
  HurricanePing: PingHurricaneIcon,
  FloodPing: PingFloodIcon,
  EarthquakePing: PingEarthquakeIcon,
  WildfirePing: PingWildfireIcon,
  SCSPing: PingSCSIcon,
  CrimePing: PingCrimeIcon,
  TsunamiPing: PingTsunamiIcon,
  LeveedAreasPing: PingLeveedAreasIcon,
  ListExpandPing: PingListExpandIcon,
  ListCollapsePing: PingListCollapseIcon,
  CsvPing: PingCsvIcon,
  JsonPing: PingJsonIcon,
  EmailPing: PingEmailIcon,
  PdfPing: PingPdfIcon,
  PowerpointPing: PingPowerpointIcon,
  ExcelPing: PingExcelIcon,
  MiscPing: PingMiscIcon,
  SinkholePing: PingSinkholeIcon,
  AlienPing: PingAlienIcon,
  DiamondX: PingDiamondXIcon,
  DiamondCheck: PingDiamondCheckIcon,
  DiamondWarning: PingDiamondWarningIcon,
};

type IconName = keyof typeof LucideIcons | keyof typeof CustomIcons;

const Icon = ({
  iconName,
  ...props
}: { iconName: IconName } & Record<string, any>) => {
  if (!iconName) return null;

  const IconComponent = LucideIcons[iconName as keyof typeof LucideIcons];

  if (!IconComponent) {
    if (iconName in CustomIcons) {
      const CustomIconComponent =
        CustomIcons[iconName as keyof typeof CustomIcons];
      return createElement(CustomIconComponent, props);
    }

    console.warn(`Icon "${iconName}" not found in Lucide / Custom library`);
    return null;
  }

  return createElement(IconComponent as React.ComponentType<any>, props);
};

export { Icon };
export type { IconName };
